import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppValidators } from 'src/app/common/appValidators';
import { ParamsForActions } from 'src/app/services/actions/common/common-actions.service';
import {
  ActionsHttpServiceService,
  AddOrRemoveOwnerParamsModel,
} from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';
import { NotificationsService } from 'src/app/services/infra/notifications/notifications.service';

@Component({
  selector: 'app-action-add-or-remove-owner',
  templateUrl: './action-add-or-remove-owner.component.html',
  styleUrls: ['./action-add-or-remove-owner.component.scss'],
})
export class ActionAddOrRemoveOwnerComponent implements OnInit {
  public emailControl: FormControl;
  public waitingForResponse = false;
  public isAddOwner = true;
  public openPlatform = false;

  constructor(
    public dialogRef: MatDialogRef<ActionAddOrRemoveOwnerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public actionsParams: ParamsForActions<AddOrRemoveOwnerParamsModel>,
    private readonly _actionsHttpService: ActionsHttpServiceService,
    private readonly _httpErrorHandlerService: HttpErrorHandlerService,
    private readonly _notificationService: NotificationsService
  ) {
    this.isAddOwner = actionsParams.requiredParams.isAddOwner;
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeWindow();
    });
  }

  ngOnInit(): void {
    this._initFormControls();
  }

  public addOrRemoveOwnerClicked(event?: MouseEvent): void {
    event?.stopPropagation();

    if (this.emailControl.valid && this.emailControl.value !== '') {
      this.waitingForResponse = true;

      const actionResponse = this.isAddOwner
        ? this._actionsHttpService.addOwner(this.actionsParams.requiredParams, this.emailControl.value)
        : this._actionsHttpService.removeOwner(this.actionsParams.requiredParams, this.emailControl.value);

      actionResponse.subscribe({
        next: () => {
          this._notificationService.success(this.isAddOwner ? 'Owner was added' : 'Owner was removed');
          this.closeWindow(this.openPlatform);
        },
        error: (httpError: HttpErrorResponse) => {
          if (this._httpErrorHandlerService.isUnhandledExceptionError(httpError.status)) {
            this._httpErrorHandlerService.handle(httpError);
          } else if (httpError.status == 404) {
            this._notificationService.error(`The email: ${this.emailControl.value} is not part of the AAD Tenant`);
          } else {
            let text = "Error without 'detail' field";
            if (typeof httpError.error.detail === 'string') {
              text = httpError.error.detail;
            }
            this._notificationService.error(
              `Owner could not be ${this.isAddOwner ? 'added' : 'removed'}, reason: ${text}`
            );
          }
          this.waitingForResponse = false;
        },
      });
    }
  }

  public closeWindow(ownerModified = false) {
    if (ownerModified && this.actionsParams.optionalParams.platformUrl) {
      window.open(this.actionsParams.optionalParams.platformUrl, '_blank');
    }
    this.dialogRef.close(ownerModified);
  }

  private _initFormControls() {
    this.emailControl = new UntypedFormControl('', [Validators.required, AppValidators.email]);
  }
}
